var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 26",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63266 0.554502C10.1034 -0.137531 11.1855 0.195629 11.1855 1.03258V8.97351C11.1855 9.44226 11.565 9.82253 12.0337 9.82354L17.5074 9.83528C18.1891 9.83674 18.5918 10.5998 18.2084 11.1634L8.88775 24.8644C8.41701 25.5564 7.3349 25.2232 7.3349 24.3863V16.445C7.3349 15.9763 6.95543 15.596 6.48669 15.595L1.01465 15.5833C0.332974 15.5818 -0.0697662 14.8188 0.313619 14.2552L9.63266 0.554502Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.2c01ad8a3f90ed6e2f8f5ed28175baa8.svg";
export { ForwardRef as ReactComponent };